import * as Constants from './constants.js';
import * as Flags from './flags.js';

const LOGO_MAPPING = {
	[Constants.EU]: Flags.FlagEU,
	[Constants.EU_COLOR]: Flags.FlagEUColor,
	[Constants.WORLD]: Flags.FlagWorld
};

export { LOGO_MAPPING, Constants };
